import React from 'react';
import { useTranslation } from 'react-i18next';

interface StepIndicatorProps {
    currentStep: number;
}

const StepIndicator: React.FC<StepIndicatorProps> = ({ currentStep }) => {
    const { t } = useTranslation();
    
    const steps = [
        { number: 1, title: t('BUSINESS_INFORMATION') },
        { number: 2, title: t('CONTACT_INFORMATION') },
        { number: 3, title: t('PREFERENCES') }
    ];

    return (
        <>
        <div className="step-indicator">
            {steps.map((step, index) => (
                <React.Fragment key={step.number}>
                    <div className="step-item">
                        <div className={`step-circle ${currentStep === step.number ? 'active' : currentStep > step.number ? 'completed' : ''}`}>
                            {step.number.toString().padStart(2, '0')}
                        </div>
                        <span className="step-title">{step.title}</span>
                    </div>
                    {index < steps.length - 1 && <div className="step-divider"></div>}
                </React.Fragment>
            ))}
        </div>
        </>
    );
};

export default StepIndicator;